import {gql} from '@apollo/client';

import * as Net from 'util/Net';

export interface SkillSummary {
  id: string;
  name: string;
  description: string;
  createdAt: string | null;
  isOwnedByCurrentUser: boolean;
  creatorName?: string;
}

export const AGENT_SKILLS_QUERY = gql`
  query AgentSkillsQuery @engComponent(name: LLM) @skipAudit {
    agentSkills {
      id
      name
      description
      createdAt
      creatorId
      creatorName
    }
  }
`;

export interface AgentSkillsQueryData {
  agentSkills: Array<{
    id: string;
    name: string;
    description: string;
    createdAt: string;
    creatorId: string | null;
    creatorName: string | null;
  }>;
}

export function createSkill(s3Location: string): Promise<{skillId: string}> {
  return Net.postJSONPromise({url: '/1/api/llm/agent-skills', data: {s3Location}});
}

export function updateSkill(
  skillId: string,
  updates: {name?: string; description?: string}
): Promise<{skillId: string}> {
  return Net.patchJSONPromise({url: `/1/api/llm/agent-skills/${skillId}`, data: updates});
}

export async function archiveSkill(skillId: string, reason?: string): Promise<void> {
  await Net.postJSONPromise({
    url: `/1/api/llm/agent-skills/${skillId}:archive`,
    data: {reason: reason ?? ''},
  });
}

export async function unarchiveSkill(skillId: string): Promise<void> {
  await Net.postJSONPromise({url: `/1/api/llm/agent-skills/${skillId}:unarchive`, data: {}});
}
